import {
  HStack,
  Icon,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import { ElementType, ReactNode } from 'react'
import { HiChevronDown } from 'react-icons/hi'

type FilterPopoverButtonProps = {
  label: string
  icon?: ElementType
  selected?: boolean
}

export const FilterPopoverButton = (props: FilterPopoverButtonProps) => {
  const { label, icon, selected } = props

  return (
    <PopoverTrigger>
      <HStack
        justify="space-between"
        position="relative"
        as="button"
        fontSize="sm"
        borderWidth="1px"
        zIndex="11"
        rounded="lg"
        paddingStart="2.5"
        paddingEnd="1.5"
        paddingY="1.5"
        spacing="1"
        data-selected={selected || undefined}
        _expanded={{ bg: mode('gray.100', 'gray.700') }}
        _selected={{ bg: 'blue.50', borderColor: 'blue.500' }}
      >
        {icon && <Icon as={icon} boxSize="2" />}
        <Text fontWeight="medium">{label}</Text>
        <Icon as={HiChevronDown} fontSize="xl" color="gray.400" />
      </HStack>
    </PopoverTrigger>
  )
}

type FilterPopoverContentProps = {
  header?: string
  children?: ReactNode
}

export const FilterPopoverContent = (props: FilterPopoverContentProps) => {
  const { header, children } = props
  
  return (
    <PopoverContent w='full' _focus={{ shadow: 'none', outline: 0 }} _focusVisible={{ shadow: 'outline' }}>
      {header && <PopoverHeader srOnly>{header}</PopoverHeader>}
      <PopoverBody padding="6">{children}</PopoverBody>
    </PopoverContent>
  )
}
